import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];

  connect() {
    console.log("Produit JS en cours ...");
    super.connect();
    var self = this;
    console.log("current app: " + this.current_app)
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      //this.show_edition_multiple();
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
    }
    if ($("#partial-sousproduits-content").length && $("#partial-sousproduits-content").text().trim() == "Chargement en cours ...") {
      //on est sur le show
      setTimeout(() => this.sousproduits_hm_ajax(), 300);
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }

  sousproduits_hm_ajax() {
    if (this.current_app && this.produit_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/produits/show_ajax_for_hm?produit_id=" +
        this.produit_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-sousproduits-content").html("");
          $("#partial-sousproduits-content").html(text);
        })
      );
    }
  }

  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A")
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }


  rerender() {
    var row = $("#search");
    var row2 = $("#quick_sort");
    row.insertAfter(row2);
  }



  get params() {
    return this.data.get("params");
  }

  get produit_ids() {
    return this.data.get("produit_ids");
  }

  get produit_id() {
    return this.data.get("produitid");
  }

  get current_app() {
    return this.data.get("app");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }
}
